<template>
  <div class="slider-box">
    <!-- Using the slider component -->
    <slider ref="slider" :options="options">
      <!-- slideritem wrapped package with the components you need -->
      <slideritem v-for="(item, index) in computedItems" :key="index" class="slider-item">
        <div class="img-container" @click="handleClick(item.achievementUrl, item.companyName)">
          <el-image :src="item.showUrl" alt="">
            <div slot="placeholder" v-loading="true" />
          </el-image>
        </div>
      </slideritem>
      <!-- Customizable loading -->
      <div slot="loading">loading...</div>
    </slider>
  </div>
</template>
<script>
import { slider, slideritem } from 'vue-concise-slider'
export default {
  components: {
    slider,
    slideritem,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      //Slider configuration [obj]
      options: {
        currentPage: 0,
        tracking: false,
        thresholdDistance: 100,
        thresholdTime: 1000,
        // infinite: 4,
        slidesToScroll: 1,
        loopedSlides: 3,
        loop: true,
        autoplay: '3000',
        pagination: false,
      },
    }
  },
  computed: {
    computedItems() {
      return this.items.map((el) => {
        return {
          ...el,
          imageUrls: (el.achievementUrl || '').split(',').filter(Boolean),
          showUrl: (el.achievementUrl || '').split(',').filter(Boolean)[0],
        }
      })
    },
  },
  methods: {
    handleClick(url, companyName) {
      this.$emit('click', url, companyName)
    },
  },
}
</script>
<style lang="less" scoped>
.slider-box {
  width: 1082px;
  height: 145px;
  .slider-item {
    margin-left: 18px;
    width: 257px;
    .img-container {
      width: 100%;
      cursor: pointer;
      padding: 6px;
      background: #fff;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
      /deep/.el-image {
        width: 100%;
        height: 131px;
        overflow: visible;
        img {
          width: 100%;
          object-fit: cover;
          height: 131px;
        }
      }
    }
  }
}
</style>
